import { FieldError, UseFormRegister } from "react-hook-form"
import { SerializedStyles } from "@emotion/react"
import { WaveInputs } from "./form"

export enum OrdersColumn {
  SYMBOL = "Ticker",
  SIDE = "Side",
  AMOUNT_USD = "USD",
  QUANTITY = "Quantity",
  ORDER_TYPE = "Type",
  LIMIT_PRICE = "Limit",
  BROKER = "Broker",
  EXECUTION_TYPE = "Execution",
  AUCTION_TYPE = "Auction",
  EXECUTION_CAP_PCT = "CAP",
  TIME_IN_MARKET = "Time in Market",
  TARGET_END_DATETIME = "Target End",
  EXECUTION_DETAILS = "Execution details",
}

export enum WaveStatus {
  CREATED = "Created",
  SENT = "Sent",
  FAILED = "Failed",
  RECEIVED = "Received",
  PASSED = "Passed",
  PARTIALLY_PASSED = "Partially passed",
  NOT_PASSED = "Not passed",
  CSV_UPLOAD_ERROR = "CSV Upload Error",
}

export enum Side {
  BUY = "buy",
  BUY_COVER = "buy_cover",
  SELL = "sell",
  SELL_SHORT = "sell_short",
}

export enum OrderType {
  MARKET = "market",
  LIMIT = "limit",
}

// Type to represent a ticker item in BookSuggest
export type BookItem = {
  value: number
  label: string
}

export type ITickerItem = {
  ticker: string
  isNew?: boolean // Flag to identify new items
}

export interface IBaseInputProps {
  name: string
  register: UseFormRegister<WaveInputs>
  customCss?: SerializedStyles
  error?: FieldError
  index?: number
}

// Short locate types
export interface ShortLocatePayload {
  instrument_id: number
  broker: string
  quantity: number
}

export interface ShortLocateResponse {
  message: string
  locate?: ShortLocate
}

export interface ShortLocateListResponse {
  data: ShortLocate[]
}

export interface ShortLocate {
  id: number
  symbol: string
  broker: string
  locate_id: string
  time: string
  initial_quantity: number
  current_quantity: number
  status: string
  expiration_time: string | null
  requested_quantity: number
  created_by: string
}

export enum OrderStatus {
  CREATED = "created",
  STAGED = "staged",
  TRADABLE = "tradable",
  CANCELLED = "cancelled",
  CANCELLED_FOR_REPLACEMENT = "cancelled_for_replacement",
  PARTIALLY_FILLED = "partially_filled",
  FILLED = "filled",
  REJECTED = "rejected",
  LOCATE_FAILED = "locate_failed",
  LOCATE_SUBMITTED = "locate_submitted",
  LOCATE_PENDING = "locate_pending",
  LOCATE_ERROR = "locate_error",
  REPLACE_FAILED = "replace_failed",
  BEING_REPLACED = "being_replaced",
  REPLACE_PENDING = "replace_pending",
}
